import { Menu, MenuItem, ListItemText, Divider } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import { FILTER_OPTIONS, READ_STATUS_OPTIONS } from '../../../helpers/utils'

export default function NotificationFilter({
  anchorEl,
  open,
  onClose,
  viewFilter,
  readStatusFilter,
  onFilterSelect,
  onReadStatusSelect,
}) {
  const handleFilterClick = (optionKey) => {
    onFilterSelect(optionKey)
    onClose()
  }

  const handleReadStatusClick = (statusKey) => {
    onReadStatusSelect(statusKey)
    onClose()
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          minWidth: 220,
          mt: 1,
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          borderRadius: 2,
        },
      }}
    >
      {READ_STATUS_OPTIONS.map((opt) => {
        const isSelected = readStatusFilter === opt.key
        return (
          <MenuItem
            key={opt.key}
            onClick={() => handleReadStatusClick(opt.key)}
            sx={{
              py: 1,
              px: 2,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              backgroundColor: isSelected
                ? 'rgba(25, 118, 210, 0.08)'
                : 'transparent',
              '&:hover': {
                backgroundColor: isSelected
                  ? 'rgba(25, 118, 210, 0.12)'
                  : 'grey.50',
              },
            }}
          >
            <ListItemText
              primary={opt.label}
              sx={{
                '& .MuiListItemText-primary': {
                  fontWeight: isSelected ? 600 : 400,
                  color: isSelected ? 'primary.main' : 'text.primary',
                  fontSize: '0.875rem',
                },
              }}
            />
            {isSelected && (
              <CheckIcon
                sx={{
                  color: 'primary.main',
                  fontSize: 18,
                  ml: 1,
                }}
              />
            )}
          </MenuItem>
        )
      })}

      <Divider sx={{ my: 1 }} />

      {FILTER_OPTIONS.map((opt) => {
        const isSelected = viewFilter === opt.key
        return (
          <MenuItem
            key={opt.key}
            onClick={() => handleFilterClick(opt.key)}
            sx={{
              py: 1,
              px: 2,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              backgroundColor: isSelected
                ? 'rgba(25, 118, 210, 0.08)'
                : 'transparent',
              '&:hover': {
                backgroundColor: isSelected
                  ? 'rgba(25, 118, 210, 0.12)'
                  : 'grey.50',
              },
            }}
          >
            <ListItemText
              primary={opt.label}
              sx={{
                '& .MuiListItemText-primary': {
                  fontWeight: isSelected ? 600 : 400,
                  color: isSelected ? 'primary.main' : 'text.primary',
                  fontSize: '0.875rem',
                },
              }}
            />
            {isSelected && (
              <CheckIcon
                sx={{
                  color: 'primary.main',
                  fontSize: 18,
                  ml: 1,
                }}
              />
            )}
          </MenuItem>
        )
      })}
    </Menu>
  )
}
